import React from "react";

import { Button, Stack, Typography } from "@mui/material";
import Box, { BoxProps } from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";
import { useModals } from "hooks";
import { IConfirmModal } from "store/types/modals";

const style: BoxProps["sx"] = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
  maxWidth: "750px",
  minWidth: "600px",
  borderRadius: "10px",
  overflow: "hidden",
  bgcolor: "white"
};

export const Confirm: React.FC<IConfirmModal> = ({ msg, title = "", action, onCancel, actionLabel }) => {
  const { closeConfirmModal } = useModals();
  return (
    <Modal open={!!msg} onClose={closeConfirmModal}>
      <Box sx={style}>
        <SimpleHeadMui onIconClick={closeConfirmModal}>{title}</SimpleHeadMui>
        <Stack sx={{ p: "20px", gap: "20px" }}>
          <Box sx={{ minHeight: "100px" }}>
            <Typography sx={{ color: "#0a3243", fontSize: "18px", lineHeight: "1.6", whiteSpace: "pre-line" }}>{msg}</Typography>
          </Box>
          <Stack direction="row" gap="30px" sx={{ justifyContent: "flex-end" }}>
            <Button
              onClick={() => {
                action?.();
                closeConfirmModal();
              }}
              variant="contained"
            >
              {actionLabel ?? "Confirm"}
            </Button>
            <Button
              onClick={() => {
                onCancel?.();
                closeConfirmModal();
              }}
              variant="outlined"
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
